export enum AlertFilterValue {
  UnreadAndRead = 'unreadAndRead',
  UnreadOnly = 'unreadOnly',
  Archived = 'archived',
}

export enum AlertBulkActionValue {
  MarkAllRead = 'markAllRead',
  ArchiveAllRead = 'archiveAllRead',
  ArchiveAll = 'archiveAll',
}

/** Filter option for alerts and notifications. */
export interface IAlertFilterOption {
  label: string;
  value: AlertFilterValue;
  iconUrl: string;
}

/** Bulk action option for alerts and notifications. */
export interface IAlertBulkActionOption {
  label: string;
  value: AlertBulkActionValue;
  iconUrl: string;
}

/** Item for alerts and notifications */
export interface IAlertTestItem {
  id: string;
  title: string;
  body: string;
  read_at: Date | null;
  sent_at: Date;
  archived_at: Date | null;
  iconPath: string;
  targetUrl: string;
}
